import React from "react";

/**
 * Shadcn-styled Recharts tooltip. `formatter(value, key)` returns a display string.
 */
export function ChartTooltip({ active, payload, label, formatter, labelFormatter }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-lg border bg-popover px-3 py-2 text-popover-foreground shadow-md">
      {label != null && (
        <p className="mb-1 text-xs font-semibold">{labelFormatter ? labelFormatter(label) : label}</p>
      )}
      <div className="space-y-0.5">
        {payload.map((p, i) => (
          <div key={i} className="flex items-center justify-between gap-4 text-xs">
            <span className="flex items-center gap-1.5 text-muted-foreground">
              <span className="h-2 w-2 rounded-full" style={{ background: p.color || p.fill }} />
              {p.name}
            </span>
            <span className="font-medium tabular-nums">
              {formatter ? formatter(p.value, p.dataKey, p) : p.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
